//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head() {
    return {
      script: [
        {
          type: "text/javascript",
          src: "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js",
          async: true,
          defer: true
        },
      ],
    };
  },
  props: {
    extraClass: {
      required: false,
    },
    dataTag: {
      required: false,
      default: "",
    },
  },
  mounted() {
    if (window.Trustpilot)
      this.$nextTick(() =>
        window.Trustpilot.loadFromElement(this.$refs.trustBoxRef)
      );
  },
  computed: {
    theme() {
      if (this.extraClass && this.extraClass === "reviews-dark-blue") {
        return "dark";
      }
      return "light";
    },
  },
};
